import _Vue from 'vue';

import { setBaseUrl, setStylesheetUrls } from '@/Common/Runtime/host';

import { deprecateProperties } from '@/Common/Utils/Dev/deprecate';

import { setTransport } from '@/Framework/app/rest/TransportService';

import pkg from '../../package.json';

// TODO Deprecated. Will remove
import * as DataUtils from '@/Common/Utils/General/Modules/data';

// Initialize all strongly Framework entity
const init = ({
	Vue = _Vue,
	transport,
	baseApiUrl = '',
	stylesheetUrls = [],
	isTest = false
}: Partial<Host.IInitFWOptions> = {}): typeof _Vue => {
	setTransport(baseApiUrl, isTest, transport);

	// Set private variables
	setBaseUrl(baseApiUrl);
	setStylesheetUrls(stylesheetUrls);

	return Vue;
};

const version = process.env.SYNC_STAMP ? `${pkg.version}-dev-${process.env.SYNC_STAMP}` : pkg.version;

export default init;

// TODO Deprecated. Will remove
const deprecatedProperties = Object.keys(DataUtils).reduce(
	(acc, curr) => ({
		...acc,
		[curr]: `ux1Data.${curr}`
	}),
	{}
);
const _DataUtils = deprecateProperties(DataUtils, deprecatedProperties, 'DataUtils is deprecate, use ux1Data instead.');

export {
	version,
	// TODO Deprecated. Will remove
	_DataUtils as DataUtils
};

// Application utils
export { createEmitter, restHelpers, sagaHelpers, getEventsMethods, getAnalyticsMethods } from '@/Framework/app/app';
export { createAnalyticsAction } from '@/Framework/app/store/actions/creators';
export { default as getMainContainer } from '@/Framework/app/components/MainContainer/MainContainer';
export { default as getSharedComponent } from '@/Framework/app/components/SharedComponent/SharedComponent';
export { default as BaseRestModule } from '@/Framework/app/store/BaseRestModule';
export { default as RouteModule } from '@/Framework/app/store/RouteModule';
export { default as NotificationsModule } from '@/Framework/app/store/NotificationsModule';
export { default as RestApi } from '@/Framework/app/rest/RestApi';
export { getT } from '@/Framework/app/translate';
export * as Noties from '@/Framework/app/store/NotificationsModule';
export * as mixinsApp from '@/Framework/app/mixins';

// Tests
export { mockTransportService } from '@/Framework/app/rest/TransportService';

// Vendors
export * as VuexSimple from 'vuex-simple';
export * as VueTypedi from 'vue-typedi';
export * as VuexSaga from 'vuex-coolstory';
export * as ReduxSaga from 'redux-saga';
export * as VeeValidate from 'vee-validate';
export { _Vue as Vue };

// Common
export { version as UIKitVer } from 'ux1-ui-kit';
